import { useState } from "react";

export const useSnackbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState(0);

  const showSuccess = (msg: string) => {
    setMessage(msg);
    setAlertType(2);
    setIsOpen(true);
  };

  const showError = (error: Error | string) => {
    setMessage(typeof error === "string" ? error : error.message || "Hata oluştu");
    setAlertType(3);
    setIsOpen(true);
  };

  const snackbarProps = {
    message,
    open: isOpen,
    onClose: () => setIsOpen(false),
    alertType,
  };

  return { showSuccess, showError, snackbarProps };
};
